const MARQUEE_ITEMS = [
  "MAY 26–31, 2026",
  "★ KAOGMA GROUNDS · CAPITOL COMPLEX ★",
  "TENT + CAR CAMPING",
  "★ THE HOTTEST FESTIVAL IN THE WORLD ★",
  "BINI",
  "BEN & BEN",
  "LOLA AMOUR",
  "EARL AGUSTIN",
  "JESSY KANG",
  "EL MANU",
  "SPONGECOLA",
  "DILAW",
  "IV OF SPADES",
  "GLOC 9",
  "UNCLE DAGS",
  "PAUL N BALLIN",
  "HELLMERY",
  "NEW:ID",
  "SIX PART INVENTION",
  "RCK GLOBAL",
  "KATE TORRES BAND",
];

export const LandingMarquee = () => (
  <div className="bg-[#FFB400] border-b-2 border-[#3D1E6D] overflow-hidden">
    <div className="flex whitespace-nowrap kf-marquee py-2">
      {Array.from({ length: 2 }).map((_, i) => (
        <div key={i} className="flex shrink-0">
          {MARQUEE_ITEMS.map((t, j) => (
            <span key={j} className="display text-2xl px-6 text-[#3D1E6D] tracking-tight">
              {t}
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
